import React, { useState } from 'react';
import { Controller, useForm } from "react-hook-form";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DButton from '../components/DButton';
// import Navbar from '../components/navbar/NavBar';
import Footer from '../components/Footer';
import ReCAPTCHA from 'react-google-recaptcha';
import toast, { Toaster } from 'react-hot-toast';
import { BASE_URL, FORGOT_PASSWORD } from '../utills/ApplicationRouting';
import { setToken } from '../redux/Qps';
import { useDispatch } from 'react-redux';
import CommonContainer from "../components/CommonContainer";
import { Link } from "react-router-dom";
import { TextField, Typography, Button } from "@mui/material";
const ForgotPasswordForm = () => {
  const { handleSubmit, control, formState: { errors } } = useForm();
  const navigate = useNavigate();
  // const BASE_URL = "http://10.64.26.139:7000/api/v1";
  // const onSubmit = async (data) => {
  //   console.log("Submitted");
  //   // Implement your forgot password logic here
  // };
 
  const dispatch = useDispatch();
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleVerify = (token) => {
    if (token) {
      setIsCaptchaValid(true);
    } else {
      setIsCaptchaValid(false);
    }
    console.log(token);
  };

  const onSubmit = (data) => {
    setIsLoading(true);
    if (!isCaptchaValid) {
      toast.error("You must complete the CAPTCHA to proceed");
      setIsLoading(false);
      return;
    }
    const postData = {
      email: data.email,
      password: data.password,
    };

    axios
      .post(`${BASE_URL}${FORGOT_PASSWORD}`, postData)
      .then((res) => {
        console.log(res);

        if (res.status == 200) {
          console.log(res.data.token);
          setTimeout(() => {
            navigate("/login");
          }, 2000);
          toast.success(res.data);
          dispatch(setToken(res.data.token))
          localStorage.setItem("contact", res.data.contact)
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error.response.data.message);
        if (error.res && error.res.status !== 200) {
          console.log(error.res.data.message);
        }
      });

  };

  return (
    <>
    {/* <Navbar /> */}
    <Toaster/>
      <div className="w-full bg-gray-100">
  <CommonContainer>
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
          <Typography
  variant="h6"
  component="span"
  align="center"
  className="block w-full font-bold"
>
  Forgot Password
</Typography>

<br />
          <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-4">
              <Controller
                name="email"
                control={control}
                defaultValue=""
                rules={{
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/,
                    message: "Please enter a valid email address"
                  },
                }}
                render={({ field }) => (
                  <TextField
                    fullWidth
                    {...field}
                    label={<><span>Email</span> <span className="text-red-500">*</span></>}
                    // Add required symbol
                    error={!!errors.email}
                    helperText={errors.email?.message}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            </div>
           <div className="flex justify-start">
  <ReCAPTCHA
    sitekey="6Ldi5P0pAAAAACIh0yfyOCIkE2xlLDMTLRIW90Oq"
    onChange={handleVerify}
  />
</div>
           <Button
  type="submit"
  variant="contained"
  fullWidth
  sx={{
    backgroundColor: "#153E75", // Contact Us dark navy blue
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "0.875rem",
    fontWeight: 600,
    borderRadius: "6px",
    py: 1,
    "&:hover": {
      backgroundColor: "#1E88E5", // Logo blue
    },
  }}
>
  Forgot Password
</Button>
            <div className="flex items-center justify-center mt-4">
              <Link to="/login" className="text-blue-700 text-center text-sm block">
  Sign In
</Link>
            </div>
          </form>
          <br />

<div className="text-gray-600 text-center" style={{ fontSize: "10px" }}>
  Enter your registered email address to receive a password reset link.
</div>
        </div>
      </div>
       </CommonContainer>
</div>
       {/* <Footer /> */}
     </>
  );
};

export default ForgotPasswordForm;
